import { render, staticRenderFns } from "./TemplateGuidelines.vue?vue&type=template&id=2b0c3354&scoped=true"
import script from "./TemplateGuidelines.vue?vue&type=script&lang=js"
export * from "./TemplateGuidelines.vue?vue&type=script&lang=js"
import style0 from "./TemplateGuidelines.vue?vue&type=style&index=0&id=2b0c3354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c3354",
  null
  
)

export default component.exports